/*
 * Copyright 2019 Mia srl
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {IntlProvider} from 'react-intl'
import moment from 'moment'
import 'moment/locale/it'

import PromiseComponent from './components/utils/PromiseComponent'
import {store, persistor} from './redux-store'
import App from './App'
import * as serviceWorker from './serviceWorker'
import messages from './strings'

import './index.css'
import 'antd/dist/antd.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'

import '@fontsource/roboto'

moment.locale('it')
const language = 'it'

const rootComponent = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <PromiseComponent promiseFunction={messages[language]}>
        {strings => (
          <IntlProvider locale={language} messages={strings}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
              <App />
            </BrowserRouter>
          </IntlProvider>
        )}
      </PromiseComponent>
    </PersistGate>
  </Provider>
)

ReactDOM.render(rootComponent, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register()
